import { Controller } from "@hotwired/stimulus";

// Show/hide a cascade option block; reset its checkboxes when hidden so an
// unselected cascade never submits a flag. Stateless, so it lives outside the
// controller class.
function toggleCascade(element, show) {
  if (!element) return;

  element.classList.toggle("d-none", !show);
  if (!show) {
    element
      .querySelectorAll('input[type="checkbox"]')
      .forEach((cb) => (cb.checked = false));
  }
}

export default class extends Controller {
  static targets = [
    "checkbox",
    "countInput",
    "selectAll",
    "total",
    "submitBtn",
    "cardCascade",
    "keyCascade",
  ];

  toggleAll() {
    const checked = this.selectAllTarget.checked;
    this.checkboxTargets.forEach((cb) => (cb.checked = checked));
    this.countInputTargets.forEach((input) => {
      input.value = checked ? input.max : 0;
    });
    this.updateTotal();
  }

  updateTotal() {
    let total = 0;
    let anySelected = false;

    this.checkboxTargets.forEach((cb) => {
      if (cb.checked) {
        total += parseInt(cb.dataset.amount, 10) || 0;
        anySelected = true;
      }
    });

    this.countInputTargets.forEach((input) => {
      const qty = parseInt(input.value, 10) || 0;
      if (qty > 0) {
        total += qty * (parseInt(input.dataset.unitAmount, 10) || 0);
        anySelected = true;
      }
    });

    this.totalTarget.textContent = `$${(total / 100).toFixed(2)}`;
    this.submitBtnTarget.disabled = !anySelected;

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked =
        this.checkboxTargets.length > 0 &&
        this.checkboxTargets.every((cb) => cb.checked);
    }

    this.updateCascadeOptions();
  }

  // Reveal card/key cascade options only when a selected unit produced that
  // artifact; hide-and-reset so an unselected cascade never submits a flag.
  updateCascadeOptions() {
    const cardSelected = this.checkboxTargets.some(
      (cb) => cb.checked && cb.dataset.artifact === "card",
    );
    const keySelected =
      this.checkboxTargets.some(
        (cb) => cb.checked && cb.dataset.artifact === "key",
      ) ||
      this.countInputTargets.some(
        (input) =>
          (parseInt(input.value, 10) || 0) > 0 &&
          input.dataset.artifact === "key",
      );

    toggleCascade(this.hasCardCascadeTarget && this.cardCascadeTarget, cardSelected);
    toggleCascade(this.hasKeyCascadeTarget && this.keyCascadeTarget, keySelected);
  }

  confirmSubmit(event) {
    const total = this.totalTarget.textContent;

    if (!confirm(`Are you sure you want to issue a refund totaling ${total}?`)) {
      event.preventDefault();
    }
  }
}
